import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { useHandbook } from '~/hooks';

const { Option } = Select;

interface Props {
  placeholder?: string;
  [x: string]: any;
}

const CountryInput: FC<Props> = (props) => {
  const { placeholder, ...rest } = props;
  const { t } = useTranslation();
  const { data, isLoading } = useHandbook();

  return (
    <Select {...rest} placeholder={placeholder || t('country')} loading={isLoading}>
      {data?.countries?.map((item) => {
        const { id } = item;
        return (
          <Option key={id} value={id || ''}>
            {t(`countries:${id}`)}
          </Option>
        );
      })}
    </Select>
  );
};

export default CountryInput;
